(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer-menus"]) return;
  try {
    
  (() => {
    const mobile = window.matchMedia('(max-width: 767px)');
    function initFooterMenus(scope) {
      scope.querySelectorAll('[data-footer-menus]').forEach((footer) => {
        if (footer.dataset.initialized) return;
        footer.dataset.initialized = 'true';
        const columns = footer.querySelectorAll('.tr-footer-menus__column');
        function syncColumns() {
          const collapsible = mobile.matches && footer.dataset.collapse === 'true';
          columns.forEach((column) => {
            column.open = !collapsible;
            column.querySelector('summary').tabIndex = collapsible ? 0 : -1;
          });
        }
        columns.forEach((column) => {
          column.addEventListener('toggle', () => {
            if ((!mobile.matches || footer.dataset.collapse !== 'true') && !column.open) column.open = true;
          });
        });
        const controller = new AbortController();
        mobile.addEventListener('change', syncColumns, { signal: controller.signal });
        document.addEventListener('shopify:section:unload', (event) => {
          if (event.target.contains(footer)) controller.abort();
        }, { signal: controller.signal });
        syncColumns();
      });
    }
    initFooterMenus(document);
    document.addEventListener('shopify:section:load', (event) => initFooterMenus(event.target));
    document.addEventListener('shopify:block:select', (event) => {
      const group = event.target.closest('[data-footer-menu-group]');
      if (group) group.closest('details').open = true;
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
